import { render } from "./buscarTarjeta.vue?vue&type=template&id=ee4e20a2"
import script from "./buscarTarjeta.vue?vue&type=script&lang=js"
export * from "./buscarTarjeta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__